import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class AssociatedSecurity extends BaseDangerDetail {
    constructor(props) {
        super(props);
    }

    getColumns = () => {
        return [{
            title: '关联担保额',
            dataIndex: 'relateGuarantee'
        }, {
            title: '所有者权益',
            dataIndex: 'ownerEquity'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/AssociatedSecurity.jsx